/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventorySummaryByResource extends models.InventorySummaryBase {
    getFixupPrototypeFunction() { return InventorySummaryByResource.fixupPrototype; }

    static newInstance(model: Partial<InventorySummaryByResource>): InventorySummaryByResource {
        let obj = Object.assign(new InventorySummaryByResource(), model);
        InventorySummaryByResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventorySummaryByResource>): InventorySummaryByResource {
        if (!model) return null;
        return InventorySummaryByResource.newInstance(<InventorySummaryByResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventorySummaryByResource) {
        if (!obj) return;

        models.InventorySummaryByResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventorySummaryByResource): boolean {
        if (models.InventorySummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InventorySummaryByResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.tagged_count === undefined) {
            this.tagged_count = 0;
        }
    }

    /**
     * Resources discovered under it
     */
    count: number;

    /**
     * How many of those carry at least one tag. Counted from the tags array rather than the is_tagged flag, which is not yet written on records discovered before it existed. Subtract from count for the untagged ones.
     */
    tagged_count: number;

}
